<p-toast position="bottom-center"></p-toast>

<div class="card md-form-shell">
  <form [formGroup]="roleForm" (ngSubmit)="saveRole()" novalidate autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="off">
    <div class="card-container bg-gray-100 border-round mt-2 p-4">
      <div class="mr-5 flex align-items-center mb-3">
        <i class="pi pi-shield mr-2 text-3xl"></i>
        <div class="font-medium text-3xl text-900">{{ pageTitle }}</div>
      </div>

      <div class="grid formgrid p-fluid">
        <div class="field col-12 md:col-6">
          <label for="roleName" class="block text-900 font-medium mb-2">Role Name</label>
          <input id="roleName" type="text" pInputText formControlName="roleName" class="w-full" />
          <small *ngIf="roleForm.get('roleName')?.invalid && roleForm.get('roleName')?.touched" class="p-error">
            Role Name is required.
          </small>
        </div>

        <div class="field col-12 md:col-6">
          <label for="description" class="block text-900 font-medium mb-2">Description</label>
          <textarea rows="3" cols="30" pTextarea formControlName="description" class="w-full"></textarea>
        </div>

        <div class="field col-12">
          <h2 class="font-bold mb-2 block">Permissions</h2>
          <div *ngIf="!permissionsLoaded && !permissionsLoadFailed" role="status">Loading permissions...</div>
          <div *ngIf="permissionsLoadFailed" role="alert">
            Failed to load permissions.
            <button type="button" (click)="getAllPermissions()">Retry</button>
          </div>
          <div *ngFor="let group of groupedPermissions" class="mb-4">
            <div class="font-bold mb-2">{{ group.resourceName }}</div>
            <div *ngFor="let action of group.permissions" class="inline-block">
              <p-checkbox
                styleClass="w-4 h-4 m-2"
                [binary]="true"
                [inputId]="'perm-' + action.id"
                [value]="action.id"
                [ariaLabel]="action.action"
                (onChange)="togglePermission(action.id)"
                [ngModel]="isPermissionSelected(action.id)"
                [ngModelOptions]="{ standalone: true }"
              ></p-checkbox>
              <label for="perm-{{ action.id }}">{{ action.action }}</label>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="flex justify-end gap-2 mt-4">
      <p-button label="Cancel" styleClass="p-button-secondary" type="button" (onClick)="cancel()"></p-button>
      <p-button [label]="isEditMode ? 'Update Role' : 'Save Role'" type="submit" [disabled]="roleForm.invalid || !permissionsLoaded"></p-button>
    </div>
  </form>
</div>
